<template>
  <div class="profile">
    <van-nav-bar title="我的" fixed />
    <h1>Profile</h1>
  </div>
</template>

<script>
export default {
  name: 'Profile'
}
</script>

<style>

</style>